import React, { useState, useEffect } from 'react';
import { getOfficeLocation } from '../asiosConfig';
import { toast } from 'react-toastify';
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Link,
  Skeleton,
} from '@mui/material';
import Navbar from './Navbar';
import Footer from './Footer';
import imageMap from "../images/map.png";

import { styled } from '@mui/system';

export const Center = () => {
  const [location, setLocation] = useState([]);
  const [loading, setLoading] = useState(true);

  const MapWrapper = styled(Box)(({ theme }) => ({
    borderRadius: theme.shape?.borderRadius || 4,
    overflow: 'hidden',
    boxShadow: theme.shadows?.[3] || '0px 3px 6px rgba(0, 0, 0, 0.1)',
    marginBottom: theme.spacing(4),
}));

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await getOfficeLocation();
        if (response.status === 200 || response.status === 201) {
          setLocation(response.data.data);
        } else {
          toast.error('Something went wrong');
        }
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to fetch location');
      } finally {
        setLoading(false);
      }
    };
    fetchLocation();
  }, []);

  return (
    <Box>
      <Navbar />
      <Box mt={12} mb={5}>
        <Container>
          <Box textAlign="center" mb={5}>
            <Typography
              variant="h4"
              component="h3"
              gutterBottom
              sx={{ fontFamily: "Montserrat" }}
            >
              IND Matrimony Centers
            </Typography>
            <Typography variant="body1" color="textSecondary" mb={5}>
              Visit your nearest IND Matrimony Center for expert customer support, detailed guidance, and personalized matchmaking solutions to help you find your perfect partner with ease.
            </Typography>

             {/* Google Map Skeleton */}
                                <MapWrapper>
                                    { (
                                        <iframe
                                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4579.932360590312!2d79.0803076!3d21.108429099999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4bf722c40cc11%3A0x82677bbea3008218!2sIND%20Matrimony!5e1!3m2!1sen!2sin!4v1762844284580!5m2!1sen!2sin"
                                            width="100%"
                                            height="450"
                                            style={{ border: 0 }}
                                            allowFullScreen=""
                                            loading="lazy"
                                            referrerPolicy="no-referrer-when-downgrade"
                                            title="Google Maps Embed"
                                        ></iframe>
                                    )}
                                </MapWrapper>
          </Box>

          <Grid container spacing={4} justifyContent="center">
            {loading
              ? Array.from({ length: 6 }).map((_, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card>
                    <Skeleton
                      variant="rectangular"
                      width="100%"
                      height={200}
                    />
                    <CardContent>
                      <Skeleton variant="text" width="60%" height={30} />
                      <Skeleton variant="text" width="80%" />
                      <Skeleton variant="text" width="70%" />
                      <Skeleton variant="text" width="90%" />
                      <Skeleton variant="text" width="50%" />
                    </CardContent>
                  </Card>
                </Grid>
              ))
              : location.length === 0
                ? (
                  <Grid item xs={12}>
                    <Typography variant="h6" align="center">
                      No Location Found
                    </Typography>
                  </Grid>
                )
                : location.map((loc, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index} textAlign={'left'}>
                    <Card>
                      {/* <CardMedia
                        component="img"
                        alt={loc.location_name}
                        height="200"
                        image={imageMap}
                        title={loc.location_name}
                      /> */}
                      <CardContent>
                        <Typography variant="h5" component="h2" gutterBottom>
                          {loc.location_name}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          <b>Address:</b> {loc.address}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          <b>Timing:</b> {loc.time_from} to {loc.time_to}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          <b>Phone:</b> {loc.phone}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          <b>Email:</b>{' '}
                          <Link href={`mailto:${loc.email}`} underline="hover">
                            {loc.email}
                          </Link>
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
          </Grid>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};
